import { DateTime } from 'luxon';

type TimeLeft = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
};

export const calculateTimeLeft = (endTs: number): TimeLeft | null => {
  const diff = endTs - Date.now() / 1000;
  if (diff > 0) {
    return {
      days: Math.floor(diff / (60 * 60 * 24)),
      hours: Math.floor((diff / (60 * 60)) % 24),
      minutes: Math.floor((diff / 60) % 60),
      seconds: Math.floor(diff % 60),
    };
  }
  return null;
};

export function formatTime(timestamp: number): string {
  return new Date(timestamp).toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
}

export const formatDuration = (seconds: number) => {
  const hrs = Math.floor(seconds / 3600);
  const mins = Math.floor((seconds % 3600) / 60);
  const secs = Math.floor(seconds % 60);

  const formattedHrs = hrs < 10 ? `0${hrs}` : hrs;
  let formattedMins = mins < 10 ? `0${mins}` : mins;
  const formattedSecs = secs < 10 ? `0${secs}` : secs;

  if (hrs === 0) {
    formattedMins = mins;
    return `${formattedMins}:${formattedSecs}`;
  }
  return `${formattedHrs}:${formattedMins}:${formattedSecs}`;
};

export const formatDateShort = (ts: number) => {
  // November 18, 2020 @ 12:00 pm
  return DateTime.fromSeconds(ts).toFormat('DD @ t');
};

export const getTimeAgoTxt = (seconds: number) => {
  let interval = seconds / 31536000;

  if (interval > 1) {
    return `${Math.floor(interval)} years`;
  }
  interval = seconds / 2592000;
  if (interval > 1) {
    return `${Math.floor(interval)} months`;
  }
  interval = seconds / 86400;
  if (interval > 1) {
    return `${Math.floor(interval)} days`;
  }
  interval = seconds / 3600;
  if (interval > 1) {
    return `${Math.floor(interval)} hours`;
  }
  interval = seconds / 60;
  if (interval > 1) {
    return `${Math.floor(interval)} minutes`;
  }
  return `${Math.floor(seconds)} seconds`;
};

export const calculateTs = (date: string, time: string): number => {
  // Ensure time is properly formatted (e.g., pad single-digit hours)
  const formattedTime = time.padStart(5, '0'); // Ensures "4:00" becomes "04:00"
  const combinedDateTime = `${date}T${formattedTime}:00`;
  const dateTimeObject = new Date(combinedDateTime);

  return Math.floor(dateTimeObject.getTime() / 1000);
};

export const secondsToDaysAndHours = (seconds: string | number) => {
  let s = typeof seconds === 'string' ? parseInt(seconds) : seconds;

  const days = Math.floor(s / (3600 * 24));
  s -= days * 3600 * 24;
  const hours = Math.floor(s / 3600);
  return { days, hours };
};
